import React from 'react';

import '../../styles/components/ClickableCard.css';

type Props = {
  caption: string;
  helpText: string;
  variant: 'primary' | 'secondary';
  onClick: () => void;
  disabled?: boolean;
};

const ClickableCard = (props: Props) => {
  return (
    <button
      onClick={props.onClick}
      className={`btn btn-${
        props.variant === 'primary' ? 'primary' : 'default'
      } btn-block btn-clickable-card`}
      disabled={props.disabled}
    >
      <h4>{props.caption}</h4>
      <p>{props.helpText}</p>
    </button>
  );
};

export default ClickableCard;
